import { NotificationProvider } from "@circle-react-shared/Notifications/NotificationContext";
import { useNotificationsWidth } from "@circle-react-shared/Notifications/useNotificationsWidth";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useWindowResize } from "@circle-react/hooks/utils/useWindowResize";

import { Body } from "@/react/components/shared/uikit/HeaderV3/RightActionBlock/Notifications/Body";
import { Header } from "@/react/components/shared/uikit/HeaderV3/RightActionBlock/Notifications/Header";
import { useNotificationsApi } from "@/react/hooks/notifications/useNotificationsApi";

interface NotificationsListProps {
  handleClose?: () => void;
}

export const NotificationsList = ({ handleClose }: NotificationsListProps) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const { resizeNotificationWindow } = useNotificationsApi();

  const { tabsContainerRef, tabsContainerWidth } = useNotificationsWidth();

  useWindowResize(resizeNotificationWindow);

  return (
    <NotificationProvider onClose={handleClose}>
      <div
        className={classNames("h-full w-fit", {
          "pointer-events-none": isViewOnlyMasquerading,
        })}
        id="notifications-drawer"
        data-testid="notifications-drawer"
      >
        <Header onClose={handleClose} />
        <Body
          tabsContainerRef={tabsContainerRef}
          tabsContainerWidth={tabsContainerWidth}
        />
      </div>
    </NotificationProvider>
  );
};
